import React from "react";
import { Form, Input, Button, Card } from "antd";
import { PlusOutlined, DeleteOutlined, CopyrightCircleOutlined } from "@ant-design/icons";
import { defaultFooterContent } from "./defaults";
import type { SectionMeta } from "./types";

export const meta: SectionMeta = {
  key: "footer_content",
  label: "Footer Content",
  icon: <CopyrightCircleOutlined />,
  color: "#6b7280",
  desc: "Copyright text, footer description and contact",
};

export const defaultData = defaultFooterContent;

export const Preview: React.FC<{ data: any[] }> = ({ data }) => {
  if (data.length === 0) return null;
  const item = data[0];
  return (
    <div className="space-y-1 text-sm">
      <div className="text-gray-500 text-xs truncate">
        {item.copyright_text}
      </div>
      <div className="text-gray-500 text-xs truncate">
        {item.footer_description}
      </div>
    </div>
  );
};

export const FormFields: React.FC = () => (
  <Form.List name="footer_content">
    {(fields, { add, remove }) => (
      <>
        {fields.map((field) => (
          <Card
            key={field.key}
            className="!mb-3"
            size="small"
            type="inner"
            extra={
              <Button
                type="text"
                danger
                size="small"
                onClick={() => remove(field.name)}
                icon={<DeleteOutlined />}
              />
            }
          >
            <div className="grid grid-cols-2 gap-3">
              <Form.Item
                {...field}
                name={[field.name, "copyright_text"]}
                label="Copyright Text"
                className="!mb-0"
                rules={[{ required: true, message: "Required" }]}
              >
                <Input placeholder="e.g. Copyright 2024. All rights reserved." />
              </Form.Item>
              <Form.Item
                {...field}
                name={[field.name, "footer_description"]}
                label="Footer Description"
                className="!mb-0"
              >
                <Input placeholder="Brief footer description" />
              </Form.Item>
              <Form.Item
                {...field}
                name={[field.name, "footer_email"]}
                label="Footer Email"
                className="!mb-0"
              >
                <Input placeholder="info@example.com" />
              </Form.Item>
              <Form.Item
                {...field}
                name={[field.name, "footer_phone"]}
                label="Footer Phone"
                className="!mb-0"
              >
                <Input placeholder="+94 77 123 4567" />
              </Form.Item>
            </div>
          </Card>
        ))}
        <Button
          type="dashed"
          block
          onClick={() => add(defaultFooterContent[0])}
          icon={<PlusOutlined />}
          className="!mb-1"
        >
          Add Footer Content
        </Button>
      </>
    )}
  </Form.List>
);
